import { render, staticRenderFns } from "./EmployeeSummaryDetails.vue?vue&type=template&id=c58f60c0&scoped=true&lang=pug"
import script from "./EmployeeSummaryDetails.vue?vue&type=script&lang=ts"
export * from "./EmployeeSummaryDetails.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeSummaryDetails.vue?vue&type=style&index=0&id=c58f60c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58f60c0",
  null
  
)

export default component.exports